import { memo } from 'react'
import clsx from 'clsx'
import ToggleIcon from './components/ToggleIcon'
import LogoutButton from '../components/LogoutButton'
import Menus from '../components/Menus'
import { useAppSelector } from '../../hooks/useStore'

const Sidebar = () => {
  const { isToggle } = useAppSelector((state) => state.dashboardUi.sidebar)

  return (
    <aside
      className={clsx(
        'hidden lg:block max-h-[calc(100vh-4rem)] py-4 shadow-[-1px_0_2px_0px_rgba(0,0,0,0.05)] ease-in-out bg-neutral-50 z-10',
        isToggle ? 'w-[72px] duration-300' : 'w-60',
      )}
    >
      <div className='flex flex-col justify-between h-full'>
        <div className='overflow-y-auto scrollbar px-5'>
          {/* toggle icon for toggling menu */}
          <div className=' flex justify-end'>
            <ToggleIcon />
          </div>
          {/* menus */}
          <div className=''>
            <Menus />
          </div>
        </div>
        {/* logout */}
        <LogoutButton />
      </div>
    </aside>
  )
}

export default memo(Sidebar)
